import React from 'react'
import ReactDOM from 'react-dom/client'
import Root from '../app/root'
import './index.css'
import { initScrollbarWidth } from './utils/scrollbarWidth'
import { installChunkReloadHandler } from './utils/chunkReload'

// 部署后旧 chunk hash 失效时自动刷新一次，避免懒加载路由（procurement 等）
// 掉进 "Failed to fetch dynamically imported module" 错误页。必须在 render 前安装。
installChunkReloadHandler()

// 初始化滚动条宽度计算，防止页面震动
initScrollbarWidth()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
)